import { SMS_DESIGNER } from "../../constants/action-types";

const initialState = {
  // beeAuth: undefined,
  // beeUnsavedChanges: false,
  // onTemplateSaved: [],
  saveSMSDesign: [],
  smsAutomatedComplianceResponse: null,
  isListSendSMS : false,
  clientSMSDesigns: [],
  // onSend: [],
  // seedList: [],
  // testEmailList: [],
  sendTestMessage: [],
  // templateList: [],
  // stockFolderList: [],
  // templateByID: [],
  smsDesignList: [],
  smsDesignByID: [],
  smsUnsubscribeTextList: [],
  smsDesignFolders: [],
  // trackingParams: [],
  unPublishMessage: [],
  pauseMessage: [],
  resumeSMS: [],
  smsDesignDuplicated: [],
  moveMessage: [],
  smsArchive: [],
  smsfolderRenamed: [],
  smsfolderAdded: [],
  // suppressionList: [],
  smsAudienceCampaignList: [],
  smsSent: [],
  smsKeyword: null,
  smsAudienceByFieldData: null,
  getAllSMSFoldersTreeview: [],
  userSelectedMergeTags : [],
  rawEditorContent: {
    blocks: [
      {
        key: 'initial',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
    ],
    entityMap: {},
  },
  // replyAddresses: [],
  // fromAddresses: [],
  // defualtValues: [],
  // imageLibraryContent: [],
  // selectedFolderName: "",
  // addDirectory: [],
  // uploadImage: [],
  // validateUpload: [],
  // deleteContent: [],
  // replaceImage: [],
  smsReportOverViewEmailSummary: [],
  smsReportDetails: [],
  smsSummaryMonthlyMetrics: [],
  // reportOverViewOpenAndClickRat: [],
  // topBottomPerformingSummary: [],
  smsDesignsCount: [],
  // clientDesigns: [],
  clientSMSDesignDetail: [],
  subscriberReportData: [],
  // subscriberTopLinks: [],
  // subscriberMostopens: [],
  // subscribersDetails: [],
  // touchPointMapping: [],
  // //saveTouchPointMapping: [],
  // imageLibraryFolders: [],
  // scheduleTrigger: [],
  // saveScheduleInformation: [],
  // designBreadcrumbs: [],
  // templateBreadcrumbs: [],
  mrgeTags: [],
  // movedImages: [],
  // imageLibraryBreadcrumbs: [],
  // clientFonts: [],
  smsDesignScheduleTrigger: [],
  smsDiConfigId: 0,
  smsDisabledSchedule_info: [],
  // sendsPage: [],
  // isAppendTrackingParams: [],
  // dynamicFields: [],
  // dynamicContentFields: [],
  // designInterval:null,
  // externalUrlValid: false,
  // externalImages: [],
  // externalCategories: [],
  // savedRowsCategories: [],
  // savedRows: [],
  // onSaveRow: [],
  // saveRowWarningMessage: "",
  sendSMSSendTo: null,
  sendSMSFrom: null,
  // sendEmailProperties: null,
  // sendEmailShedule: null,
  // sendEmailPlayTouchpoint: null,
  // isCreditUsageHardLimit: false,
  // totalCredit: 0,
  // usedCredit: 0,
  // listSendFileValidationObject: null,
  creditResetDate: null,
  totalCredit: 0,
  usedCredit: 0,
  selectedImage: null,
  smsListSendFileValidationObject: null,
  smsMonthlyCreditUsage: null,
  smsDailyCreditUsage: null,
  folderId : 0

};

const SMSDesigner = (state = initialState, action) => {
  switch (action.type) {
    

    case SMS_DESIGNER.ON_SAVE_DESIGN: {
      return Object.assign({}, state, {
        saveSMSDesign: action.payload,
      });
    }
    case SMS_DESIGNER.AUTOMATED_COMPLIANCE_RESPONSE: {
      return Object.assign({}, state, {
        smsAutomatedComplianceResponse: action.payload,
      });
    }
    case SMS_DESIGNER.SEND_TEST_MESSAGE: {
      return Object.assign({}, state, {
        sendTestMessage: action.payload,
      });
    }
    case SMS_DESIGNER.IS_LIST_SEND:{
      return Object.assign({}, state, {
        isListSendSMS: action.payload
      });
    }
    case SMS_DESIGNER.GET_ALL_DESIGNS: {
      return Object.assign({}, state, {
        smsDesignList: action.payload,
      });
    }
    case SMS_DESIGNER.GET_DESIGN_BY_ID: {
      return Object.assign({}, state, {
        smsDesignByID: action.payload,
      });
    }
    case SMS_DESIGNER.GET_SMS_UNSUBSCRIBETEXT_LIST: {
      return Object.assign({}, state, {
        smsUnsubscribeTextList: action.payload,
      });
    }
    case SMS_DESIGNER.GET_MONTHLY_SMS_CREDIT_USAGE: {
      return Object.assign({}, state, {
        smsMonthlyCreditUsage: action.payload,
      });
    }
    case SMS_DESIGNER.UPDATE_FOLDER_ID: {
      return Object.assign({}, state, {
        folderId: action.payload,
      });
    }
    case SMS_DESIGNER.GET_DAILY_SMS_CREDIT_USAGE: {
      return Object.assign({}, state, {
        smsDailyCreditUsage: action.payload,
      });
    }
    case SMS_DESIGNER.GET_ALL_FOLDERS: {
      return Object.assign({}, state, {
        smsDesignFolders: action.payload,
      });
    }
  
    case SMS_DESIGNER.UNPUBLISH: {
      return Object.assign({}, state, {
        unPublishMessage: action.payload,
      });
    }
    case SMS_DESIGNER.PAUSE: {
      return Object.assign({}, state, {
        pauseMessage: action.payload,
      });
    }
    case SMS_DESIGNER.RESUME: {
      return Object.assign({}, state, {
        resumeSMS: action.payload,
      });
    }
    case SMS_DESIGNER.DUPLICATE: {
      return Object.assign({}, state, {
        smsDesignDuplicated: action.payload,
      });
    }
    case SMS_DESIGNER.MOVE: {
      return Object.assign({}, state, {
        moveMessage: action.payload,
      });
    }

    case SMS_DESIGNER.RENAME: {
      return Object.assign({}, state, {
        smsfolderRenamed: action.payload,
      });
    }
    case SMS_DESIGNER.ADD_FOLDER: {
      return Object.assign({}, state, {
        smsfolderAdded: action.payload,
      });
    }

    case SMS_DESIGNER.AUDIENCE_CAMPAIGN_LIST: {
      return Object.assign({}, state, {
        smsAudienceCampaignList: action.payload,
      });
    }
    case SMS_DESIGNER.SEND_SMS: {
      return Object.assign({}, state, {
        smsSent: action.payload,
      });
    }

    case SMS_DESIGNER.CREATE_SMS_KEYWORD: {
      return Object.assign({}, state, {
        smsKeyword: action.payload,
      });
    }
    case SMS_DESIGNER.GET_SMS_KEYWORD: {
      return Object.assign({}, state, {
        smsKeyword: action.payload,
      });
    }
    case SMS_DESIGNER.GET_AUDIENCE_BY_FIELD_DATA: {
      return Object.assign({}, state, {
        smsAudienceByFieldData: action.payload,
      });
    }
    case SMS_DESIGNER.RESET_SMS_SEND_STATE: {
      return initialState;
    }

    case SMS_DESIGNER.GET_ALL_SMS_FOLDERS_TREEVIEW: {
      return Object.assign({}, state, {
        getAllSMSFoldersTreeview: action.payload,
      });
    }
    
    case SMS_DESIGNER.REPORT_OVERVIEW_SMS_SUMMARY: {
      return Object.assign({}, state, {
        smsReportOverViewEmailSummary: action.payload,
      });
    }
    case SMS_DESIGNER.REPORT_SMS_DETAILS: {
      return Object.assign({}, state, {
        smsReportDetails: action.payload,
      });
    }
    case SMS_DESIGNER.REPORT_SMS_SUBSCRIBER_DETAILS: {
      return Object.assign({}, state, {
        subscriberReportData: action.payload,
      });
    }
    case SMS_DESIGNER.SMS_SUMMARY_Monthly_Metrics: {
      return Object.assign({}, state, {
        smsSummaryMonthlyMetrics: action.payload,
      });
    }
    case SMS_DESIGNER.DESIGN_COUNT_BY_CLIENT: {
      return Object.assign({}, state, {
        smsDesignsCount: action.payload,
      });
    }
    case SMS_DESIGNER.DESIGN_DROPDOWN_BY_CLIENT: {
      return Object.assign({}, state, {
        clientSMSDesigns: action.payload,
      });
    }
    case SMS_DESIGNER.DESIGN_SMS_DETAIL: {
      return Object.assign({}, state, {
        clientSMSDesignDetail: action.payload,
      });
    }
   
    case SMS_DESIGNER.MERGE_TAGS: {
      return Object.assign({}, state, {
        mrgeTags: action.payload,
      });
    }
  
    case SMS_DESIGNER.USER_SELECTED_MERGE_TAGS: {
      const newTag = action.payload;
    
      return {
        ...state,
        userSelectedMergeTags: Array.isArray(newTag)
          ? [...state.userSelectedMergeTags, ...newTag]  // flatten array
          : [...state.userSelectedMergeTags, newTag],    // single object
      };
    }

    case SMS_DESIGNER.DELETE_USER_SELECTED_MERGE_TAG: {
      return {
        ...state,
        userSelectedMergeTags: state.userSelectedMergeTags.filter(
          (tag) => tag.mergeTagName !== action.payload
        ),
      };
    }

    case SMS_DESIGNER.EDITOR_STATE: {
      
      return {
        ...state,
        rawEditorContent :action.payload
      };
    }
    case SMS_DESIGNER.UPDATE_DESIGN_SCHEDULE_TRIGGER: {
      return Object.assign({}, state, {
        smsDiConfigId: action.payload,
      });
    }
    case SMS_DESIGNER.GET_DESIGN_SCHEDULE_TRIGGER: {
      return Object.assign({}, state, {
        smsDesignScheduleTrigger: action.payload,
      });
    }
    case SMS_DESIGNER.LIST_SEND_FILE_VALIDATION: {
      return Object.assign({}, state, {
        smsListSendFileValidationObject: action.payload,
      });
    }
    case SMS_DESIGNER.DISABLED_SCHEDULED: {
      return Object.assign({}, state, {
        smsDisabledSchedule_info: action.payload,
      });
    }
 
    case SMS_DESIGNER.SEND_SMS_SEND_TO: {
      return {
        ...state,
        sendSMSSendTo: action.payload,
      };
    }
    case SMS_DESIGNER.SEND_SMS_FROM: {
      return {
        ...state,
        sendSMSFrom: action.payload,
      };
    }
    
    case SMS_DESIGNER.GET_SMS_USER_CREDIT: {
      const {
        payload: { creditResetDate, totalCredit, usedCredit, hardTotalCredit },
      } = action;
      return {
        ...state,
        creditResetDate: creditResetDate,
        totalCredit: totalCredit,
        usedCredit: usedCredit,
        hardTotalCredit: hardTotalCredit,
      };
    }
    case SMS_DESIGNER.SELECTED_IMAGE: {
      return Object.assign({}, state, {
        selectedImage: action.payload,
      });
    }
    
    default:
      return state;
  }
};

export default SMSDesigner;
